<template lang="pug">
b-modal(
  ref="rejectModal"
  id="reject-ove-modal"
  hide-footer
  centered
  size="md"
  no-close-on-backdrop
)
  template(#modal-header="{ close }")
    h5.modal-title.font-weight-bold ¿Seguro que deseas rechazar esta cotización?
    b-icon.close-icon(icon="x" @click="close()")

  .modal-body-content.text-center
    .warning-icon-container.mb-4
      b-icon(icon="exclamation-triangle-fill" variant="danger" font-scale="4")
    
    p.warning-text
      strong Esta acción es irreversible. 
      | Al confirmar el rechazo, la oportunidad se cerrará y se liberará inmediatamente el stock de los equipos que estaban reservados para este cliente.

    .equipment-list.mt-4
      .item-card(v-for="item in ovedetail.detalles" :key="item.id")
        .item-image
          img(v-if="item.imagen_url" :src="formatImgUrl(item.imagen_url)")
          b-icon(v-else icon="laptop" font-scale="1.5")
        .item-info.text-left
          p.item-name {{ item.equipo_nombre || item.modelo }}
          p.item-price {{ item.precio_total | formatCurrency }}

    .actions-row.mt-5.d-flex.justify-content-center.gap-3
      b-button.btn-cancel(@click="hide") Cancelar
      b-button.btn-reject(@click="confirmReject" :disabled="loading") 
        b-spinner(small v-if="loading")
        span(v-else) Cancelar Cotización
</template>

<script>
import { mapActions } from 'vuex'
import { backUrl } from '../../../settings'

export default {
  name: 'RejectOVEModal',
  props: {
    ovedetail: {
      type: Object,
      default: () => ({
        detalles: [],
      }),
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions('OVEStore', ['rechazarOve']),
    show() {
      this.$refs.rejectModal.show()
    },
    hide() {
      this.$refs.rejectModal.hide()
    },
    formatImgUrl(url) {
      if (!url) return null
      if (url.startsWith('http')) return url
      return `${backUrl}${url}`
    },
    async confirmReject() {
      this.loading = true
      try {
        await this.rechazarOve({
          ove_id: this.ovedetail.id,
          comentario_cierre: 'Rechazada por el vendedor desde el Center',
        })
        this.hide()
        this.$emit('rejected')
        this.$bvToast.toast('Cotización rechazada exitosamente', {
          variant: 'success',
          noCloseButton: true,
        })
      } catch (error) {
        console.error('Error al rechazar OVE:', error)
        this.$bvToast.toast('Error al rechazar la cotización', {
          variant: 'danger',
          noCloseButton: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.modal-title {
  color: #23201c;
  font-size: 18px;
}

.close-icon {
  font-size: 24px;
  cursor: pointer;
  color: #525252;
}

.modal-body-content {
  padding: 10px 20px;
}

.warning-text {
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  color: #525252;
  line-height: 1.4;
}

.equipment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item-card {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  border: 1px solid #525252;
  border-radius: 8px;
  background: #ffffff;

  .item-image {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .item-info {
    .item-name {
      font-size: 14px;
      color: #525252;
      margin-bottom: 2px;
      font-weight: 500;
    }
    .item-price {
      font-size: 14px;
      color: #1d4ed8;
      font-weight: 700;
      margin: 0;
    }
  }
}

.actions-row {
  gap: 15px;

  .btn-cancel {
    background-color: #f5f6fa;
    border: 1px solid #525252;
    color: #525252;
    border-radius: 8px;
    height: 45px;
    padding: 0 30px;
    font-weight: 600;

    &:hover {
      background-color: darken(#f5f6fa, 5%);
    }
  }

  .btn-reject {
    background-color: $samtek-yellow;
    border: none;
    color: $samtek-black;
    border-radius: 8px;
    height: 45px;
    padding: 0 30px;
    font-weight: 600;

    &:hover {
      background-color: darken($samtek-yellow, 5%);
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
}

::v-deep .modal-header {
  border-bottom: none;
  padding: 20px 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
